import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { PhysicalRisk } from "@/entities/physical-risk/model/physical-risk.types"
import physicalRiskStore from "@/entities/physical-risk/model/physical-risk.store"
import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"

export default function useOpenPhysicalRiskFromQuery(risks: PhysicalRisk[]) {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const activeRisk = useAppSelector(physicalRiskStore.selectors.active)
  const queryRiskId = new URLSearchParams(location.search).get("riskId")

  useEffect(() => {
    if (!queryRiskId) return

    const risk = risks.find((item) => item.id === queryRiskId)
    if (!risk && activeRisk.id !== queryRiskId) return

    if (risk && activeRisk.id !== queryRiskId) dispatch(physicalRiskStore.thunks.visit(risk))

    const params = new URLSearchParams(location.search)
    params.delete("riskId")
    const search = params.toString()
    navigate(`${location.pathname}${search ? `?${search}` : ""}`, { replace: true })
  }, [activeRisk.id, dispatch, location.pathname, location.search, navigate, queryRiskId, risks])
}
